import React from 'react';

import { Skeleton, Grid } from '@mui/material';

import { COLOR } from '../../../helpers/colors';

const textBox = <Skeleton variant="text" animation="wave" color={COLOR.PH} />;

const QuotationDetailsPlaceholder = () => (
  <Grid sx={{ marginY: 6 }}>
    <Grid
      style={{
        border: `1px solid ${COLOR.borderColor}`,
        borderBottomLeftRadius: 5,
        borderBottomRightRadius: 5,
      }}
    >
      <Grid
        item
        xs={12}
        container
        direction="row"
        justifyContent="center"
        sx={{
          background: COLOR.textColor,
          color: COLOR.whiteTextColor,
          padding: 3,
          textTransform: 'uppercase',
          borderTopLeftRadius: 5,
          borderTopRightRadius: 5,
        }}
      >
        {textBox}
      </Grid>
      <Grid
        item
        xs={12}
        container
        direction="row"
        justifyContent="space-between"
        sx={{ paddingY: 2, paddingX: 1, background: COLOR.bgColor }}
      >
        <Grid item xs={2}>
          {textBox}
          {textBox}
          {textBox}
        </Grid>
        <Grid item xs={2}>
          {textBox}
          {textBox}
          {textBox}
          {textBox}
        </Grid>
        <Grid item xs={2}>
          {textBox}
          {textBox}
          {textBox}
          {textBox}
        </Grid>
      </Grid>
    </Grid>
  </Grid>
);

export default QuotationDetailsPlaceholder;
